import React, { Component } from 'react';
import OtpInput from 'react-otp-input';
import $ from 'jquery';

class ForgotPassword extends Component {
    constructor() {
        super();
        this.state = {
            resetPwdMsg: false,
            disableOtp: true,
            otpValue: '',
            fields: {},
            errors: {},
            sentOtp: false
        }
    }

    generateOtpApi = (e) => {
        e.preventDefault();
        let thisController = this;
        let errors = {};
        if (this.validateform()) {
            $.ajax({
                url: "/api/forgot-password",
                type: 'POST',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
                },
                async: false,
                data: { "emailId": this.state.fields.username },
                success: function (res) {
                    if (res.success === true) {
                        thisController.setState({
                            disableOtp: false,
                            sentOtp: true
                        })
                    } else {
                        thisController.setState({
                            disableOtp: true,
                            sentOtp: false
                        });
                        errors["response"] = res.result;
                        thisController.setState({
                            errors: errors
                        });
                    }
                }
            });
        }
    }

    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({ fields });
        this.validateform();
    }

    handleOtpChange = (otp) => {
        let otpValue = this.state.otpValue;
        otpValue = otp;
        this.setState({ otpValue })
    }

    validateform = () => {
        let fields = this.state.fields;
        let errors = {};
        let fieldIsValid = true;

        if (!fields["username"]) {
            fieldIsValid = false;
            errors["username"] = "*Please enter your Email ID";
        }

        if (typeof fields["username"] !== "undefined") {
            var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
            if (!pattern.test(fields["username"])) {
                fieldIsValid = false;
                errors["username"] = "*Please enter valid Email ID";
            }
        }

        this.setState({
            errors: errors
        });
        return fieldIsValid;
    }

    validateGeneratedOtpApi = () => {
        let thisController = this;
        let errors = {};
        if (thisController.validateOtpField()) {
            $.ajax({
                url: "/api/forgot-password/validate",
                type: 'POST',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
                },
                async: false,
                data: {
                    "emailId": thisController.state.fields.username,
                    "otp": thisController.state.otpValue
                }
                ,
                success: function (res) {
                    if (res.success === true) {
                        thisController.props.history.push({
                            pathname: '/login',
                            state: { resetPwdMsg: true }
                        });
                    } else {
                        thisController.setState({
                            disableOtp: true,
                            sentOtp: false
                        });
                        errors["response"] = res.result;
                        thisController.setState({
                            errors: errors
                        });
                    }
                }
            });
        }
    }

    validateOtpField = () => {
        let errors = {};
        let otpIsValid = true;
        let otpValue = this.state.otpValue;

        if (otpValue.length !== 6) {
            otpIsValid = false;
            errors["otp"] = "*Please enter OTP"
        }

        this.setState({ errors: errors });
        return otpIsValid;
    }



    render() {
        return (
            <div className="wrapper">
                <div className="row col-md-12 p-0 m-0">
                    <div className="col-md-5">
                        <form className="form-horizontal">
                            <div className="card-body p-0">
                                <div className="row">
                                    <div className="col-lg-12 p-0">
                                        <div className="card sign-in-right-tab">
                                            <div className="card-body sign-in-page">
                                                <div className="col-sm-12">
                                                    <div className="logoBox">
                                                        <img src="./assets/images/dheeai.png" alt="" />
                                                        <h5 className="signinTitle">Forgot Password</h5>
                                                        <div className="errorMsg" style={{ color: this.state.sentOtp ? "#b2beb5" : 'red' }} name="response">{this.state.sentOtp ? "Otp has been sent to your mail" : this.state.errors.response}</div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="card-body">
                                                        <div className="col-9 p-0 mx-auto ">

                                                            <div className="input-group mb-3">
                                                                <input type="email" className="login-form" name="username" placeholder="Registered Email" onChange={this.handleChange} />
                                                            </div>
                                                            <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.username}</div>
                                                            <br /><br />
                                                            <div className="card-footera">
                                                                <button type="button" onClick={this.generateOtpApi} style={{ display: this.state.disableOtp ? "block" : "none" }} className="btn btn-primary btn-block">Proceed</button>
                                                            </div>
                                                            <OtpInput
                                                                inputStyle={{
                                                                    width: '3rem',
                                                                    height: '3rem',
                                                                    margin: '0 0.5rem',
                                                                    fontSize: '1rem',
                                                                    borderRadius: 4,
                                                                    display: this.state.disableOtp ? "none" : "block"
                                                                }}
                                                                numInputs={6}
                                                                onChange={this.handleOtpChange}
                                                            />
                                                            <div className="errorMsg" style={{ color: 'red' }} name="otp">{this.state.errors.otp}</div>

                                                            <br /><br />
                                                            <div className="card-footera">
                                                                <button type="button" onClick={this.validateGeneratedOtpApi} style={{ display: this.state.disableOtp ? "none" : "block" }} className="btn btn-primary btn-block">Verify OTP</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-7 sign-in-form-bg" />
                </div>
            </div>

        );
    }
}
export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/sales-desk/login/ForgotPassword.js